import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthenticationResult } from '@azure/msal-browser';
import { Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication/authentication.service';

@Injectable()
export class OutgoingInterceptor implements HttpInterceptor {
  private authService = inject(AuthenticationService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return this.authService
      .acquireToken(request, environment.B2E_scope, next)
      .pipe(
        switchMap((result: AuthenticationResult) => {
          const headers = request.headers.set(
            'Authorization',
            `Bearer ${result.accessToken}`,
          );
          const requestClone = request.clone({ headers });
          return next.handle(requestClone);
        }),
      );
  }
}
